import { useCompassCard } from '@scale/compass-ui/store';
import type { PassAtKContext } from '@scale/genai-compass-shared/cards/pass_at_k';
import { useGetPassAtKRunConfigByRunId } from 'react-scale/corp/views/CorpProjectGroupManager/views/Quality/PassAtK/api/apiClient';
import { useEffect } from 'react';

function usePassAtKCard(index: number) {
  const { card, updateCardCanSubmit } = useCompassCard(index);
  const context = card.defaultContext as PassAtKContext;
  const { data: runInfo, isLoading } = useGetPassAtKRunConfigByRunId({
    runId: context.runId,
    enabled: !!context.runId,
  });

  useEffect(() => {
    updateCardCanSubmit(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    runId: context.runId,
    runInfo,
    isLoading,
  };
}

export default usePassAtKCard;
